<template>
    <div class="MMyFollow" v-if="init">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!dataList.length"></NoData>
            <div class="followList">
                <div class="box" v-for="(obj, index) in dataList" :key="obj.innerid">
                    <div class="left" @click="handleAgencyView(obj)">
                        <div class="headerImg">
                            <img class="img" v-lazy="obj.logourl" alt="">
                        </div>
                        <div class="name">{{obj.orgname}}</div>
                    </div>
                    <div class="right" @click="handelCancel(obj, index)">
                        <div class="btn">取消关注</div>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
  import {uploadCourseHostFollow} from 'api/api'
  import {getMyFollowHostList} from 'api/systemApi'
  import Pull from 'views/mobile/components/pull/pull'
  import {mapActions, mapGetters} from 'vuex'
  import NoData from 'views/mobile/components/noData/noData'

  export default {
    name: 'MMyFollow',
    data() {
      return {
        init: false,
        dataList: [],
        param: {},
        page: {
          page: 1,
          pageSize: 10,
          pageCount: 0,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
      }
    },
    mounted() {
      this.setNoDataTip('当前还没有关注，快去关注收藏吧！')
      document.title = '我的关注'
      if (!this.refresh) {
        this.getList()
      }
    },
    activated() {
      if (this.refresh) {
        this.getList()
        this.setRefresh(false)
      }
    },
    methods: {
      handleAgencyView(obj) {
        this.setRefresh(true)
        if (this.domainInfo.isCourseDomain) {
          this.$router.push({name: 'MAgencyView', query: {hostid: obj.innerid}})
        } else {
          this.$router.push({name: 'AaHostView', query: {hostid: obj.innerid}})
        }
      },
      handelCancel(obj, index) {
        this.$dialog.confirm({
          title: '',
          message: '确定取消关注吗？',
          confirmButtonColor: '#409EFF'
        }).then(() => {
          this._cancelFollow(obj, index)
        }).catch(() => {
        })
      },
      _cancelFollow(obj, index) {
        this.setLoading(true)
        uploadCourseHostFollow({
          data: {
            hostid: obj.innerid,
            optype: 2
          },
          success: () => {
            this.setLoading(false)
            this.$toast.success('操作成功！')
            this.dataList.splice(index, 1)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getList() {
        this.setLoading(true)
        getMyFollowHostList({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            this.init = true
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.dataList = data.data.content
            } else {
              this.dataList = this.item.dataList.concat(data.data.content)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['refresh', 'domainInfo'])
    },
    components: {
      Pull, NoData
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";

    .MMyFollow {
        .followList {
            padding: 0.16rem 0.32rem;
            background: $c-white;
            .box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.16rem 0;
                .left {
                    display: flex;
                    align-items: center;
                    flex-grow: 1;
                    .headerImg {
                        width: 1rem;
                        height: 1rem;
                        margin-right: 0.24rem;
                        .img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                    .name {
                        color: $c-black;
                        font-size: 0.32rem;
                    }
                }
                .right {
                    .btn {
                        width: 1.4rem;
                        height: 0.46rem;
                        border-radius: 0.23rem;
                        color: $c-grey;
                        font-size: 0.26rem;
                        text-align: center;
                        line-height: 0.46rem;
                        border: 0.02rem solid $c-grey;
                    }
                }
            }
        }
        .noData {
            height: 100vh;
            background: $c-white;
        }
    }
</style>